import { Injectable } from '@angular/core';
import { User } from '@models';

@Injectable({
    providedIn: 'root'
})
export class DateFormatConfig {

    constructor(private readonly user: User) { }

    private readonly formatMap: Record<string, string> = {
        'Month DD YYYY_h11': 'MMM dd yyyy hh:mm:ss a',
        'MM/DD/YY_h11': 'MM/dd/yy hh:mm:ss a',
        'YY/MM/DD_h11': 'yy/MM/dd hh:mm:ss a',
        'DD/MM/YY_h11': 'dd/MM/yy hh:mm:ss a',
        'DD/MM/YYYY_h11': 'dd/MM/yyyy hh:mm:ss a',

        'Month DD YYYY_h23': 'MMM dd yyyy HH:mm:ss',
        'MM/DD/YY_h23': 'MM/dd/yy HH:mm:ss',
        'YY/MM/DD_h23': 'yy/MM/dd HH:mm:ss',
        'DD/MM/YY_h23': 'dd/MM/yy HH:mm:ss',
        'DD/MM/YYYY_h23': 'dd/MM/yyyy HH:mm:ss',
    };

    /** Returns the format string for the current user's date/time settings */
    public getFormat(): string {
        const key = `${this.user.dateFormat}_${this.user.timeFormat}`;
        return this.formatMap[key] ?? 'MMM dd yyyy HH:mm:ss';
    }
}
